// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__QUt3F","title":"Carousel_title__gBXaH","discount":"Carousel_discount__7wPXR","price":"Carousel_price__C6dla","striked":"Carousel_striked__B-WjN"};